import {
  Col, Card, Button,
  Input,
  CardBody, Row, Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { useState, useEffect } from 'react';
import Datetime from 'react-datetime';
import search from "../../../assets/images/search.png";
import 'react-datetime/css/react-datetime.css';
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import { useNavigate } from 'react-router-dom';
import EditForm from '../EditForm/EditForm';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import MoveReviewStatus from '../MoveReviewStatus/MoveReviewStatus';
import SendSms from '../SendSms/SendSms';
import download from "../../../assets/images/download.png";
import PaginationTable from '../PaginationTable';
import "./ReviewTable.css";
import axiosInstance from '../../../helpers/axios';
import { useSelector, useDispatch } from "react-redux";
import * as moment from 'moment';
import alerticon from "../../../assets/images/alertIcon.png";
import { handleExcelDownload } from '../../../utils/excelDownload';
import { Tooltip } from "@mui/material";
import { userActions } from '../../../actions/user.actions';
import WarningIcon from '@mui/icons-material/Warning';
import InstituteAutocomplete from '../../status/ProjectTable/InstituteSearch'
import { ApplicationStatusEnum } from '../../../data';
import RefreshIcon from '@mui/icons-material/Refresh';
// 🔹 NEW: custom hook
import useApplicationData from '../../../hooks/useApplicationData';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";

require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/en-gb');

const ReviewTable = () => {
  const datestate = useSelector((state) => state.Datefilter?.res);
  const usersearchdefstate = useSelector((state) => state?.UserSearchDefault?.res?.data?.data);
  const profileState = useSelector((state) => state?.PROFILE?.profileDetails?.res?.data);

  const dispatch = useDispatch();

  const decode = useCurrentUser();
  const user = null;

  const status = ApplicationStatusEnum.InReview;
  const navigate = useNavigate();

  // 🔹 Use shared hook for data, filters, pagination
  const {
    tableData,
    productTypeSelected,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    filterDateFrom,
    filterDateTo,
    instituteId,
    instituteName,
    selectedCRA,
    activePage,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setInstituteName,

   
    handlePageChange,          // paginate (page number)
    handleRowsPerPageChange,   // 15 / 50 / 100 / 500
    handleSearch,    
    clearFilters,          // Search Results button
    handleCRAChange,           // if you enable CRA dropdown later
  } = useApplicationData({
    status,
    user,
    dependencies: {
      datestate,
      usersearchdefstate,
      // no insubstate/usersearchinsstate for Review
    },
  });

  const valid = (current) => {
    return current.isAfter(filterDateFrom);
  };

  const [openErrorMessage, setOpenErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorItem, setErrorItem] = useState(null);

  const [errorFormFirstName, setErrorFormFirstName] = useState(null);
  const [errorFormLastName, setErrorFormLastName] = useState(null);
  const [errorFormDOB, setErrorFormDOB] = useState(null);
  const [errorFormAddress, setErrorFormAddress] = useState(null);
  const [errorFormCity, setErrorFormCity] = useState(null);
  const [errorFormState, setErrorFormState] = useState(null);
  const [errorFormPincode, setErrorFormPincode] = useState(null);

  const [instituteResetKey, setInstituteResetKey] = useState(0);
  // keep profileState -> errorItem mapping
  useEffect(() => {
    window.addEventListener("beforeunload", () =>
      sessionStorage.removeItem("TableFilters")
    );
  }, []);
  useEffect(() => {
    if (profileState) {
      setErrorItem(profileState);
    }
  }, [profileState]);

  const showErrorApplicant = (uid, appid) => {
    const profileUrl = `/summary/user?id=${uid}&applicationId=${appid}&status=In Review`;
    dispatch(userActions.getProfileDetails(profileUrl));

    dispatch({ type: appContextConstants.SET_REFETCH_CONTEXT, payload: { refetchUid: uid, refetchAppId: appid } });

    const Id = uid;
    const urlCIBIL = `/cibil/report?userId=${Id}`;

    axiosInstance.get(urlCIBIL)
      .then((res) => {
        setErrorMessage(res?.data?.data?.summary);
        setOpenErrorMessage(true);
      })
      .catch(() => {
        alert("Error While Fetching CIBIL");
      });
  };

  const showErrorCoApplicant = (uid, appid) => {
    const profileUrl = `/summary/coapplicant?id=${uid}&status=In Review`;
    dispatch(userActions.getProfileDetails(profileUrl));

    dispatch({ type: appContextConstants.SET_REFETCH_CONTEXT, payload: { refetchUid: uid, refetchAppId: appid } });

    const Id = uid;
    const urlCIBIL = `/cibil/report?userId=${Id}`;

    axiosInstance.get(urlCIBIL)
      .then((res) => {
        setErrorMessage(res?.data?.data?.summary);
        setOpenErrorMessage(true);
      })
      .catch(() => {
        alert("Error While Fetching CIBIL");
      });
  };

  const { refetchAppId, refetchUid } = useSelector(state => state.appContext);

  const reFetchCibil = () => {
    const urlSave = '/summary/update';
    const saveBody = {
      applicationId: refetchAppId,
      userId: refetchUid,
      firstName: errorFormFirstName,
      lastName: errorFormLastName,
      dateOfBirth: errorFormDOB,
      currentCity: errorFormCity,
      currentAddress: errorFormAddress,
      currentState: errorFormState,
      currentPincode: errorFormPincode,
    };
    const urlFetch = '/admin/application/retrigger-cibil-admin';
    const body = {
      applicationId: refetchAppId,
      userId: refetchUid,
    };

    axiosInstance.post(urlSave, saveBody, {
      headers: {
      }
    })
      .then((res) => {
        if (res.data.message === "Successful") {
          axiosInstance.post(urlFetch, body, {
            headers: {
            }
          })
            .then((res) => {
              if (res.data.message === "Successful") {
                window.alert("Successfully Re-Fetched CIBIL");
                setOpenErrorMessage(true);
                dispatch({ type: appContextConstants.SET_REFETCH_CONTEXT, payload: { refetchAppId: null, refetchUid: null } });
                window.location.reload();
              }
            })
            .catch(() => {
              window.alert('Error Re-Fetching');
            });
        }
      })
      .catch(() => {
        window.alert('Error Saving Details');
      });
  };

  const handleCIBIL = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { appId: applId } });
    const profileUrl = `/summary/user?id=${Id}&applicationId=${event.applicationId}&status=In Review`;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;

    // dispatch(userActions.fetchHandleuser(profileUrl, user),[])
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/review/profile', {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaPreScreen: true,
        dir: "In Review",
        coapplicants: event?.coapplicants,
        name: event?.name,
        ruleStatus: event?.ruleStatus
      },
    });
  };

  const handleCoAppCIBIL = (event) => {
    const Id = event.coapplicantId;
    const applId = event.applicationId;

    const urlProfile = `/summary/coapplicant?id=${Id}&status=In Review`;
    const ckycUrl = `/ckyc/details?userId=${Id}`;
    const digilockerUrl = `/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
    const panUrl = `/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
    const bankSelfieUrl = `/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
    const uploadedFileUrl = `/users/documents/admin?userId=${Id}`;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    const urlForBankSelfie = `/integrations/application-profile?applicationId=${event.applicationId}`;
    const getFoirRefUrl = `/admin/application/additional-info?applicationId=${event.applicationId}`;
    const urlCIBIL = `/cibil/report?userId=${Id}`;
    const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`;

    dispatch(userActions.fetchHandlcoappuser(urlProfile, user, navigate, applId, Id), []);
    dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile, user));
    dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
    dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    dispatch(userActions.getCkycDetails(ckycUrl, user));
    dispatch(userActions.getCibilDetails(urlCIBIL));
    dispatch(userActions.getPanStatus(panUrl));
    dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
    dispatch(userActions.getDigiLocker(digilockerUrl, user));
    dispatch(userActions.getProfileDetails(urlProfile));
    dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/review/profile', {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaPreScreen: true,
        dir: "In Review",
        coapplicants: event?.coapplicants,
        name: event?.name,
        ruleStatus: event?.ruleStatus
      },
    });
  };

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      selectedUserId: event.userId,
      userId: event.userId,
      coapplicantId: event?.coapplicantId
        ? (typeof event?.coapplicantId === "string")
          ? event?.coapplicantId
          : event?.coapplicantId[0]
        : "",
      appId: applId,
    }});

    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/review/profile', {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaCibil: false,
        dir: "In Review",
        coapplicants: event?.coapplicants,
        name: event?.name,
        ruleStatus: event?.ruleStatus
      },
    });
  };

  const handleCoApp = (event, coAppUserId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: coAppUserId } });
    const Id = (event?.coapplicants?.length > 1)
      ? coAppUserId
      : event?.coapplicantId
        ? (typeof event?.coapplicantId === "string")
          ? event?.coapplicantId
          : event?.coapplicantId[0]
        : "";
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;

    dispatch(userActions.getActivity(getActivityUrl, user));
    navigate('/status/review/profile', {
      state: {
        id: 1,
        profileId: Id,
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaCibil: false,
        dir: "In Review",
        clickEvent: "coapp",
        coapplicants: event?.coapplicants,
        name: event?.name,
        ruleStatus: event?.ruleStatus
      },
    });
  };

  const handleApplicationProfile = (currApplicationId, currUID, currCoAppId, item) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      coappId: currCoAppId,
      userId: currUID,
      appId: currApplicationId,
    }});
    navigate("/status/Review/appProfile", { state: item });
  };

  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : instituteId,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: 'downloadButton',
      buttonStyles: {
        width: '90px',
        marginLeft: '150px'
      }
    });
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN');
  }

  if (!tableData) {
    return <div>....Loading</div>;
  }

  return (
    <Card className="card" style={{ width: "100%", height: '100%' }}>
        <Modal isOpen={openErrorMessage}>
          <ModalHeader> Error While Fetching CIBIL</ModalHeader>
          <ModalBody>
            <p style={{ padding: '1em', color: '#d32028', textAlign: 'center' }}>{errorMessage}</p>
            <div>
              <p>To Re-Fetch CIBIL Edit Details and Save </p>
              <div style={{ display: 'block' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>First Name</p>
                  <input
                    onChange={(e) => setErrorFormFirstName(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.firstName}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>Last Name</p>
                  <input
                    onChange={(e) => setErrorFormLastName(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.lastName}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>DOB</p>
                  <input
                    onChange={(e) => setErrorFormDOB(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.dateOfBirth}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>Address</p>
                  <input
                    onChange={(e) => setErrorFormAddress(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.currentAddress}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>City</p>
                  <input
                    onChange={(e) => setErrorFormCity(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.currentCity}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>State</p>
                  <input
                    onChange={(e) => setErrorFormState(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.currentState}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1em' }}>
                  <p style={{ fontWeight: 'bold' }}>Pincode</p>
                  <input
                    onChange={(e) => setErrorFormPincode(e.target.value)}
                    style={{ width: '80%', borderRadius: '5px', border: '2px solid #F0F0F0', paddingLeft: '5px' }}
                    type="text"
                    defaultValue={errorItem?.currentPincode}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  style={{ border: 'none', backgroundColor: '#d32028', color: 'white' }}
                  onClick={reFetchCibil}
                >
                  Save and Re-Fetch CIBIL
                </Button>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setOpenErrorMessage(false)}> Close</Button>
          </ModalFooter>
        </Modal>

        <CardBody>
          <div>
            <p style={{ display: 'flex', alignItems: 'center' }}>
              <img src={statusimage} alt="" />
              <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px' }}>status</span>
              <span style={{ marginLeft: '20px', marginBottom: '3px' }}>
                <img style={{ height: "18px", width: "14px" }} src={rightarrow} alt="" />
              </span>
              <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px', color: '#D32028' }}>
                {status}
              </span>
            </p>
          </div>

          <Row>
            <div style={{ display: 'flex', flex: 'wrap' }}>
              <Col sm="12" md="10" lg="3">
                <div
                  style={{
                    height: '23px',
                    marginRight: '10px',
                    fontFamily: 'Inter',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "institute_cra" ? (
                    <Input
                      type="text"
                      id="userSearch"
                      value={decode.instituteName}
                      readOnly
                      disabled
                      placeholder={'Merchant Name'}
                      style={{
                        fontSize: '0.8vw',
                        paddingLeft: '26px',
                        fontFamily: 'Inter',
                        backgroundImage: `url(${search})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '5px center',
                        backgroundSize: '15px 15px',
                        paddingRight: '5px',
                        borderColor: '#cccccc',
                        borderStyle: 'solid',
                        borderRadius: "5px",
                        borderWidth: '1px',
                        height: '34px',
                        marginTop: '11px'
                      }}
                    />
                  ) : (
                    <InstituteAutocomplete
                        key={instituteResetKey}
                      // onInstituteSelect={(id) => setInstituteId(id)}
                        onInstituteSelect={(id, name) => {
                          setInstituteId(id);
                          setInstituteName(name || "");
                        }}
                        defaultValue={instituteName}
                      searchIcon={search}
                      handleInputChange={handleSearch}
                      placeholder={
                        decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Product Type'
                          : 'Merchant Name'
                      }
                    />
                  )}
                </div>
              </Col>

              <Col>
                <div style={{ height: '7px', marginRight: '10px', marginLeft: '12px' }}>
                  <Datetime
                    key={`fromDate-${filterDateFrom || 'empty'}`}
                    closeOnSelect="false"
                    id="fromDate"
                    dateFormat="DD MMM YYYY"
                    timeFormat={false}
                    value={filterDateFrom ? moment(filterDateFrom, 'DD MMM YYYY') : null}
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateFrom(event.format('DD MMM YYYY'));
                      } else {
                        setFilterDateFrom('');
                      }
                    }}
                    locale="en-gb"
                    inputProps={{ placeholder: 'From Date', style: { fontFamily: 'Inter', fontSize: "14px" } }}
                  />
                </div>
              </Col>

              <Col>
                <div style={{ height: '7px', marginRight: '10px' }}>
                  <Datetime
                    key={`toDate-${filterDateTo || 'empty'}`}
                    closeOnSelect="false"
                    id="toDate"
                    // key={filterDateFrom} 
                    dateFormat="DD MMM YYYY"
                    isValidDate={valid}
                    timeFormat={false}
                    locale="en-gb"
                    initialViewDate={
                      filterDateFrom
                        ? moment(filterDateFrom, 'DD MMM YYYY')
                        : moment()
                    }
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateTo(event.format('DD MMM YYYY'));
                      } else {
                        setFilterDateTo('');
                      }
                    }}
                    value={filterDateTo ? moment(filterDateTo, 'DD MMM YYYY') : null}
                    inputProps={{ placeholder: 'To Date', style: { fontFamily: 'Inter', fontSize: "14px" } }}
                  />
                </div>
              </Col>

              <Col>
                <div>
                  <button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '130px',
                      backgroundColor: '#D22129',
                      height: '34px',
                      borderStyle: 'none',
                      borderRadius: "5px",
                      color: 'white',
                      fontFamily: "Inter",
                      paddingLeft: '10px'
                    }}
                    onClick={handleSearch}
                  >
                    Search Results
                  </button>                    
                </div>
              </Col>
             
              <Col>
                <div style={{ display: 'flex', alignItems: 'center' }}>
              <button
                onClick={() => {
                  clearFilters();
                  setInstituteResetKey(prev => prev + 1);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '34px',
                  width: '42px',
                  backgroundColor: '#D22129',
                  border: 'none',
                  borderRadius: '5px',
                  color: 'white',
                  cursor: 'pointer',
                  marginLeft: '10px'
                
                }}
              >
                <RefreshIcon />
              </button> 
              </div>
              </Col>
              {decode.role === "institute_admin" ||
              decode.role === "institute_user" ||
              decode.role === "channel_user"
                ? null
                : (
                  <Col>
                    <div>
                      {/* CRA dropdown commented; if you enable it, use handleCRAChange(event.target.value) */}
                    </div>
                  </Col>
                )}

              {(decode.role === "cra" ||
                decode.role === "crsa" ||
                decode.role === "institute_cra" ||
                (decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                  decode.role === "institute_user")) ? "" : (
                <Col>
                  <button
                    style={{
                      backgroundColor: '#D22129',
                      width: '90px',
                      height: '34px',
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: "150px",
                      borderStyle: 'none',
                      borderRadius: "5px",
                      color: 'white',
                      fontFamily: "Inter"
                    }}
                    id="downloadButton"
                    onClick={handleDownloadList}
                  >
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '15px'
                      }}
                    >
                      <img
                        style={{ height: '15px', alignItems: "center", marginRight: '5px' }}
                        src={download}
                        alt="download"
                      />
                      <span>Export</span>
                    </p>
                  </button>
                </Col>
              )}
            </div>
          </Row>

          {isLoading ? (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '15%',
                backgroundColor: 'white',
                height: '100vh'
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className='tables' style={{ marginTop: '20px' }}>
                <table>
                  <thead className='table-heading'>
                    <tr>
                      <th id="appId" style={{ width: '8%', fontSize: '14px', fontFamily: 'Inter', borderTopLeftRadius: '8px' }}>
                        Appl. Id
                      </th>
                      <th style={{ fontSize: '14px', width: '12%' }} id="appname">Appl. Name</th>
                      {(decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user") &&
                      decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                        <th style={{ fontSize: '14px', fontFamily: "Inter", width: '10em' }} id="appname">
                          Student Name
                        </th>
                      ) : null}
                      <th style={{ fontSize: '14px', width: '10%' }} id="insName">
                        {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Product Type'
                          : 'Merchant Name'}
                      </th>
                      {decode.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "channel_user"
                        ? null
                        : (
                          <th style={{ fontSize: '14px', width: '10%' }} id="cibil">
                            {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "CRIF" : "Status"}
                          </th>
                        )}
                      <th style={{ fontSize: '14px', width: '8%' }} id="coursename">
                        {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Tenure" : "Course"}
                      </th>
                      <th style={{ fontSize: '14px', width: '10em' }} id="amt">Amount</th>
                      <th id="appfromdate" style={{ fontSize: '14px', width: '10%' }}>
                        Date
                      </th>
                      {decode.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "channel_user"
                        ? null
                        : (
                          <th id="cra" style={{ textAlign: 'center', fontSize: '14px', width: '10em' }}>
                            CRA
                          </th>
                        )}
                      {decode.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "user" ||
                      decode.role === "channel_user"
                        ? null
                        : (
                          <th style={{ width: '10em', fontSize: '14px' }} id="actions">
                            Actions
                          </th>
                        )}
                    </tr>
                  </thead>
                  {tableData.map((item) => (
                    <tbody className='table-body' key={item.applicationId}>
                      <tr className="table-row" style={{ lineHeight: '20px' }}>
                        {decode.role !== "institute_user" &&
                        decode.role !== "institute_admin" &&
                        decode.role !== "channel_user" ? (
                          <td>
                            <span
                              onClick={() => handleApplicationProfile(item.applicationId, item.userId, item.coapplicantId, item)}
                              style={{
                                fontFamily: "Inter",
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                width: '8em',
                              lineHeight:'1.4em',
                                  color:'#667085'
                              }}
                            >
                              {item.applicationId}
                            </span>
                          </td>
                        ) : (
                          <td
                            style={{
                              fontSize: '14px',
                              fontWeight: '400',
                              width: '12em',
                              fontFamily: "Inter"
                            }}
                          >
                            {(decode.role === "institute_user" &&
                              decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e") ? (
                              <Tooltip title={item.studentId ? item.studentId : "No StudentId"} arrow>
                                {item.applicationId}
                              </Tooltip>
                            ) : (
                              <>{item.applicationId}</>
                            )}
                          </td>
                        )}

                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? (
                          <td
                            style={{
                              fontFamily: "Inter",
                              fontWeight: '400',
                              color: '#667085',
                              fontSize: '14px',
                            }}
                          >
                            <span
                              title={item.name}
                              style={{
                                width: '15em',
                                fontFamily: "Inter",
                                fontWeight: '400',
                                color: '#667085',
                                fontSize: '14px',
                                lineHeight: '1.5em',
                                display: "block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              {item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </span>
                          </td>
                        ) : (
                          <td
                            style={{
                              fontSize: '14px',
                              color: '#101828',
                              cursor: 'pointer',
                              fontFamily: "Inter",
                              
                            }}
                          >
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                              <span
                                title={item.name}
                                style={{
                                  width: '80%',
                                  fontFamily: 'Inter',
                                  fontWeight: '400',
                                lineHeight:'1.4em',
                                  color:'#667085',
                                  fontSize: '14px',
                                  lineHeight: '1.5em',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                onClick={() => handleUser(item)}
                              >
                                {item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                              <span>
                                {item.panValid === 0 && (
                                  <img
                                    src={alerticon}
                                    alt=""
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    title='Pan validity indication'
                                  />
                                )}
                              </span>
                              {item?.bankStatementValid === 0 && (
                                <Tooltip title='Bank statement fraud detected' arrow>
                                  <WarningIcon sx={{ color: '#d22129', fontSize: 16, marginLeft: 0.5 }} />
                                </Tooltip>
                              )}
                              {item?.aaValid === 0 && (
                                <Tooltip title='Acount Aggregator fraud detected' arrow>
                                  <WarningIcon sx={{ color: '#d22129', fontSize: 16, marginLeft: 0.5 }} />
                                </Tooltip>
                              )}
                            </span>

                            {item.coapplicants && (
                              <span style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}>
                                {item?.coapplicants?.map((coapp, index) => (
                                  <span
                                    style={{ fontFamily: "Inter", marginTop: '10px', lineHeight: '1.5em' ,color:'#667085'}}
                                    onClick={() => handleCoApp(item, coapp?.coapplicantId)}
                                    key={index}
                                  >
                                    <span>
                                      {coapp?.coapplicantName?.toLowerCase().split(' ')
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} (C)
                                    </span>
                                    <span>
                                {coapp.coapplicantPanValid === 0 && (
                                  <img
                                    src={alerticon}
                                    alt=""
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    title='Pan validity indication'
                                  />
                                )}
                              </span>
                                  </span>
                                ))}
                              </span>
                            )}
                          </td>
                        )}

                        {(decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user") &&
                        decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                          <td title={item.studentName}>
                            <span
                              style={{
                                width: '10em',
                                fontWeight: '400',
                                fontSize: '14px',
                                color: '#667085',
                                fontFamily: "Inter",
                                display: "block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              {item.studentName ? item.studentName : "-"}
                            </span>
                          </td>
                        ) : null}

                        <td>
                          <div className="merchant-with-source">
                            <span
                              title={item.instituteName}
                              style={{
                                fontWeight: '400',
                                fontSize: '14px',
                                color: '#667085',
                                fontFamily: "Inter",
                                maxWidth: '15em',
                                display: "block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              {item.instituteName ? item.instituteName : "-"}
                            </span>
                            {item.productType === 2 && (
                              <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                            )}
                          </div>
                        </td>

                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user"
                          ? null
                          : (
                            <td
                              style={{
                                fontSize: '14px',
                                width: '6em',
                                color: 'blue',
                                cursor: 'pointer',
                                fontFamily: "Inter",
                              }}
                            >
                              {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? (<>{item.applicantCibil !== "Error" ? (
                                <span
                                  title={item.applicantCibil === null && (Object.prototype.hasOwnProperty.call(item, 'applicantCibil'))
                                    ? "Does not exist"
                                    : item.applicantCibil}
                                  style={{ fontFamily: "Inter", fontSize: '14px' }}
                                  onClick={() => handleCIBIL(item)}
                                >
                                  {item.applicantCibil === null && (Object.prototype.hasOwnProperty.call(item, 'applicantCibil'))
                                    ? "--DNE--"
                                    : item.applicantCibil}
                                </span>
                              ) : (
                                <span onClick={() => showErrorApplicant(item.userId, item.applicationId, item)}>Error</span>
                              )}

                              {item.coapplicantName ? (
                                item.coapplicantCibil !== "Error" ? (
                                  <span
                                    title={item.coapplicantCibil === null && (Object.prototype.hasOwnProperty.call(item, 'coapplicantCibil'))
                                      ? "Does not exist"
                                      : item.coapplicantCibil}
                                    style={{ fontFamily: "Inter", fontSize: '14px' }}
                                    onClick={() => handleCoAppCIBIL(item)}
                                  >
                                    {' '}<br />
                                    {item.coapplicantCibil === null && (Object.prototype.hasOwnProperty.call(item, 'coapplicantCibil'))
                                      ? "--DNE--"
                                      : item.coapplicantCibil}
                                  </span>
                                ) : (
                                  <span onClick={() => showErrorCoApplicant(item.coapplicantId, item.applicationId, item)}>Error</span>
                                )
                              ) : ('')}</>):
                              (
                              <span
                                style={{
                                  backgroundColor: "#FEEDEE",
                                  border: "0px solid #d32028",
                                  color: "#667085",
                                  borderRadius: "8px",
                                  padding: "4px"
                                }}
                              >
                                {item.instituteName !== "Personal Loan"
                                  ? "-"
                                  : item.stage == 5
                                    ? "Bs Done"
                                    : item.stage == 4
                                      ? "Cibil Done"
                                      : item.stage == 3
                                        ? "Experian Done"
                                        : "In Process"}
                              </span>
                              )}
                              
                            </td>
                          )}

                        <td title={item.courseName}>
                          <span
                            style={{
                              fontWeight: '400',
                              fontSize: '14px',
                              color: '#667085',
                              fontFamily: "Inter",
                              width: '12em',
                              display: "block",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                              ? item?.tenure
                              : item.courseName
                                ? item.courseName
                                : "-"}
                          </span>
                        </td>

                        <td
                          style={{
                            fontSize: '14px',
                            fontWeight: '400',
                            width: '7em',
                            color: '#667085',
                            fontFamily: "Inter"
                          }}
                        >
                          {item.courseFees ? (
                            <>
                              &#8377;{formatNumberWithCommas(item.courseFees)}
                            </>
                          ) : (
                            '-'
                          )}
                        </td>

                        <td
                          title={item?.applicationDate?.substr(10, 15)}
                          style={{
                            fontWeight: '400',
                            color: '#667085',
                            fontFamily: "Inter",
                            fontSize: '14px'
                          }}
                        >
                          {item.applicationDate?.substr(0, 10)
                            ? moment(item?.applicationDate?.substr(0, 10)).format('DD MMM YY')
                            : "-"}
                        </td>

                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user"
                          ? null
                          : (
                            <td
                              title={item.cra}
                              style={{
                                fontSize: '14px',
                                fontFamily: "Inter",
                                color: '#667085',
                                fontWeight: '500',
                                textAlign: 'center',
                                width: 'auto'
                              }}
                            >
                              {item.cra
                                ? item.cra[0] + item.cra.toUpperCase().substr(item.cra.indexOf(" "), item.cra.indexOf("") + 2)
                                : null}
                            </td>
                          )}

                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "user" ||
                        decode.role === "channel_user"
                          ? null
                          : (
                            <td>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <span title="Edit Form" style={{ cursor: 'pointer' }}>
                                  <EditForm curruser={item} />
                                </span>
                                <span title="Move Status" style={{ cursor: 'pointer' }}>
                                  <MoveReviewStatus ApplicantId={item} />
                                </span>
                                <span title="Request Bank Statement" style={{ cursor: 'pointer' }}>
                                  <SendSms ApplicantId={item} />
                                </span>
                              </div>
                            </td>
                          )}
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>

              {totalFetchRows ? (
                totalFetchRows <= 100 ? (
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                    <div
                      style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontFamily: "Inter",
                        fontSize: '1vw',
                        marginLeft: '10px',
                        marginBottom: '5px'
                      }}
                    >
                      Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                      {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                      records of {totalFetchRows} |
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                       <p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                      <div>
                        <span
                          onClick={() => handleRowsPerPageChange(15)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 15 ? "#D32028" : "black",
                            backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          15
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(50)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 50 ? "#D32028" : "black",
                            backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          50
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(100)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 100 ? "#D32028" : "black",
                            backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          100
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(500)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 500 ? "#D32028" : "black",
                            backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          500
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                    <div
                      style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        justifyContent: "space-between",
                        fontFamily: "Inter-Medium",
                        fontSize: '1vw',
                        marginLeft: '10px',
                        marginBottom: '5px',
                        marginRight: '10px'
                      }}
                    >
                      Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                      {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                      records of {totalFetchRows} |
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                      <div>
                        <span
                          onClick={() => handleRowsPerPageChange(15)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 15 ? "#D32028" : "black",
                            backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          15
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(50)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 50 ? "#D32028" : "black",
                            backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          50
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(100)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 100 ? "#D32028" : "black",
                            backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          100
                        </span>
                        <span
                          onClick={() => handleRowsPerPageChange(500)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px',
                            color: activePage === 500 ? "#D32028" : "black",
                            backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                            borderRadius: '8px'
                          }}
                        >
                          500
                        </span>
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontFamily: "Inter",
                    fontSize: '14px'
                  }}
                >
                  No Records
                </div>
              )}

              <PaginationTable
                startPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalRows={totalFetchRows}
                paginate={handlePageChange}
                filterDateFrom={filterDateFrom}
              />
            </>
          )}
        </CardBody>
    </Card>
  );
};

export default ReviewTable;
